import { computed, toValue, type MaybeRefOrGetter } from 'vue'
import { keepPreviousData, useQuery } from '@tanstack/vue-query'

import { getSearchResults } from '../api'
import type { SearchParams } from '../api'

import { searchKeys } from './keys'

/**
 * Hand-written rather than `createEntityQueries`: there is no list/detail pair here, only
 * the one question. `enabled` is the caller's, and it is load-bearing — an empty box must
 * not ask.
 */
export function useSearchResults(
  params: MaybeRefOrGetter<SearchParams>,
  options?: { enabled?: MaybeRefOrGetter<boolean> }
) {
  const query = useQuery({
    queryKey: computed(() => searchKeys.list(toValue(params))),
    queryFn: ({ signal }) => getSearchResults(toValue(params), { signal }),
    enabled: computed(() => toValue(options?.enabled) ?? true),
    // The dropdown keeps the rows it has while the next answer travels, so the list does
    // not blink empty between keystrokes.
    placeholderData: keepPreviousData
  })

  return {
    ...query,
    items: computed(() => query.data.value?.data.data ?? [])
  }
}
